export default __webpack_public_path__ + "static/media/background1.9d1cff85.jpg";